module.exports = __webpack_public_path__ + "static/media/Page29.e87cb390.png";